const URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api2.charterscanners.com'
    : 'https://api2.charterscanners.com';
export default URL;
